// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DuplicatesPage.module.css */

.DuplicatesPage_container__aKxUG {
  max-width: 960px;
  margin: 0 auto;
  padding: 24px;
  font-family: 'Inter', sans-serif;
  color: #333;
}

.DuplicatesPage_title__FgbuV {
  font-size: 2rem;
  margin-bottom: 16px;
  text-align: center;
}

.DuplicatesPage_tabs__3EzGW {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  justify-content: center;
}

.DuplicatesPage_tab__i1pYH {
  flex: 1 1;
  padding: 12px 16px;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, transform 0.2s;
}

.DuplicatesPage_tab__i1pYH:hover {
  background: #e0e0e0;
  transform: translateY(-2px);
}

.DuplicatesPage_activeTab__xyCSv {
  background: #4a90e2;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.DuplicatesPage_loader__KLq6I,
.DuplicatesPage_error__x1\\+69,
.DuplicatesPage_noDuplicates__TGUoK {
  text-align: center;
  margin: 24px 0;
  font-size: 1.1rem;
}

.DuplicatesPage_globalActions__fG3P7 {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

.DuplicatesPage_selectAllBtn__Kv3b-,
.DuplicatesPage_bulkDeleteBtn__EcW2K,
.DuplicatesPage_mergeBtn__l2pq3,
.DuplicatesPage_deleteRouteBtn__metBy {
  padding: 8px 12px;
  font-size: 0.95rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
}

.DuplicatesPage_selectAllBtn__Kv3b- {
  background: #f0f0f0;
  color: #333;
}

.DuplicatesPage_selectAllBtn__Kv3b-:hover {
  background: #e0e0e0;
}

.DuplicatesPage_bulkDeleteBtn__EcW2K {
  background: #d9534f;
  color: #fff;
}

.DuplicatesPage_bulkDeleteBtn__EcW2K:disabled {
  background: #f5a19e;
  cursor: not-allowed;
}

.DuplicatesPage_bulkDeleteBtn__EcW2K:hover:not(:disabled) {
  background: #c9302c;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.DuplicatesPage_mergeBtn__l2pq3 {
  background: #5cb85c;
  color: #fff;
}

.DuplicatesPage_mergeBtn__l2pq3:hover {
  background: #4cae4c;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.DuplicatesPage_group__JGk6D {
  margin-bottom: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  overflow: hidden;
}

.DuplicatesPage_header__-i5BV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}

.DuplicatesPage_groupTitle__o3nw6 {
  font-size: 1.2rem;
  margin: 0;
}

.DuplicatesPage_list__nMkh- {
  list-style: none;
  margin: 0;
  padding: 0;
}

.DuplicatesPage_item__ZILkf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.DuplicatesPage_item__ZILkf:last-child {
  border-bottom: none;
}

.DuplicatesPage_info__66Kaa {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.95rem;
}

.DuplicatesPage_markLabel__3y0QF {
  display: flex;
  align-items: center;
  margin-right: 16px;
}

.DuplicatesPage_markLabel__3y0QF input {
  margin-right: 6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.DuplicatesPage_productsList__bN-aP {
  margin-top: 8px;
  padding-left: 16px;
  list-style: disc;
  font-size: 0.9rem;
  color: #555;
}

.DuplicatesPage_deleteRouteBtn__metBy {
  background: #e74c3c;
  color: #fff;
}

.DuplicatesPage_deleteRouteBtn__metBy:hover {
  background: #c0392b;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.DuplicatesPage_pagination__bz3dG {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0;
}

`, "",{"version":3,"sources":["webpack://./src/modules/Admin/DuplicatePage/DuplicatesPage.module.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sCAAsC;AACxC;;AAEA;;;EAGE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;EAIE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB","sourcesContent":["/* DuplicatesPage.module.css */\r\n\r\n.container {\r\n  max-width: 960px;\r\n  margin: 0 auto;\r\n  padding: 24px;\r\n  font-family: 'Inter', sans-serif;\r\n  color: #333;\r\n}\r\n\r\n.title {\r\n  font-size: 2rem;\r\n  margin-bottom: 16px;\r\n  text-align: center;\r\n}\r\n\r\n.tabs {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 24px;\r\n  justify-content: center;\r\n}\r\n\r\n.tab {\r\n  flex: 1;\r\n  padding: 12px 16px;\r\n  background: #f5f5f5;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background 0.2s, transform 0.2s;\r\n}\r\n\r\n.tab:hover {\r\n  background: #e0e0e0;\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.activeTab {\r\n  background: #4a90e2;\r\n  color: #fff;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1);\r\n}\r\n\r\n.loader,\r\n.error,\r\n.noDuplicates {\r\n  text-align: center;\r\n  margin: 24px 0;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.globalActions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.selectAllBtn,\r\n.bulkDeleteBtn,\r\n.mergeBtn,\r\n.deleteRouteBtn {\r\n  padding: 8px 12px;\r\n  font-size: 0.95rem;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.selectAllBtn {\r\n  background: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.selectAllBtn:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.bulkDeleteBtn {\r\n  background: #d9534f;\r\n  color: #fff;\r\n}\r\n\r\n.bulkDeleteBtn:disabled {\r\n  background: #f5a19e;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.bulkDeleteBtn:hover:not(:disabled) {\r\n  background: #c9302c;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.mergeBtn {\r\n  background: #5cb85c;\r\n  color: #fff;\r\n}\r\n\r\n.mergeBtn:hover {\r\n  background: #4cae4c;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.group {\r\n  margin-bottom: 24px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\r\n  overflow: hidden;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 16px;\r\n  background: #fafafa;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.groupTitle {\r\n  font-size: 1.2rem;\r\n  margin: 0;\r\n}\r\n\r\n.list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.markLabel {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-right: 16px;\r\n}\r\n\r\n.markLabel input {\r\n  margin-right: 6px;\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.productsList {\r\n  margin-top: 8px;\r\n  padding-left: 16px;\r\n  list-style: disc;\r\n  font-size: 0.9rem;\r\n  color: #555;\r\n}\r\n\r\n.deleteRouteBtn {\r\n  background: #e74c3c;\r\n  color: #fff;\r\n}\r\n\r\n.deleteRouteBtn:hover {\r\n  background: #c0392b;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 12px 0;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DuplicatesPage_container__aKxUG`,
	"title": `DuplicatesPage_title__FgbuV`,
	"tabs": `DuplicatesPage_tabs__3EzGW`,
	"tab": `DuplicatesPage_tab__i1pYH`,
	"activeTab": `DuplicatesPage_activeTab__xyCSv`,
	"loader": `DuplicatesPage_loader__KLq6I`,
	"error": `DuplicatesPage_error__x1+69`,
	"noDuplicates": `DuplicatesPage_noDuplicates__TGUoK`,
	"globalActions": `DuplicatesPage_globalActions__fG3P7`,
	"selectAllBtn": `DuplicatesPage_selectAllBtn__Kv3b-`,
	"bulkDeleteBtn": `DuplicatesPage_bulkDeleteBtn__EcW2K`,
	"mergeBtn": `DuplicatesPage_mergeBtn__l2pq3`,
	"deleteRouteBtn": `DuplicatesPage_deleteRouteBtn__metBy`,
	"group": `DuplicatesPage_group__JGk6D`,
	"header": `DuplicatesPage_header__-i5BV`,
	"groupTitle": `DuplicatesPage_groupTitle__o3nw6`,
	"list": `DuplicatesPage_list__nMkh-`,
	"item": `DuplicatesPage_item__ZILkf`,
	"info": `DuplicatesPage_info__66Kaa`,
	"markLabel": `DuplicatesPage_markLabel__3y0QF`,
	"productsList": `DuplicatesPage_productsList__bN-aP`,
	"pagination": `DuplicatesPage_pagination__bz3dG`
};
export default ___CSS_LOADER_EXPORT___;
